import { Button, Popconfirm } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowUpRightFromSquare,
  faEyeSlash,
  faPen,
  faTrashCan,
} from "@fortawesome/free-solid-svg-icons";

import { isTextHotspot } from "../utils/tourEditorUtils";
import styles from "./TourEditorSections.module.css";

export default function HotspotsSidebarSection({
  hotspots,
  addHotspotMode,
  activeSceneId,
  getTargetSceneName,
  onAddHotspot,
  onEditHotspot,
  onDeleteHotspot,
  onOpenHotspotUrl,
}) {
  return (
    <section className={styles.section}>
      <div className={styles.sectionHeader}>
        <h3>Hotspots</h3>
        <Button
          type="link"
          className={styles.addBtn}
          disabled={!activeSceneId || addHotspotMode}
          onClick={onAddHotspot}
        >
          {addHotspotMode ? "Click Sphere..." : "+ Add"}
        </Button>
      </div>

      <div className={styles.list}>
        {hotspots.map(hotspot => {
          const isText = isTextHotspot(hotspot);
          const webUrl = isText ? hotspot.webUrl?.trim() : "";
          return (
            <div key={hotspot.id} className={styles.hotspotItem}>
              <div className={styles.hotspotInfo}>
                <span className={styles.hotspotName}>
                  {hotspot.name?.trim()
                    ? hotspot.name.split(/\r?\n/)[0].trim()
                    : "Untitled"}
                  {hotspot.isHidden && (
                    <FontAwesomeIcon
                      icon={faEyeSlash}
                      className={styles.hiddenIndicator}
                      title="Hidden hotspot"
                    />
                  )}
                </span>
                <span className={styles.hotspotTarget} title={webUrl || undefined}>
                  {isText
                    ? `Text${webUrl ? ` · ${webUrl}` : ""}`
                    : `Navigation → ${getTargetSceneName(hotspot.targetSceneId)}`}
                </span>
              </div>
              <div className={styles.listItemActions}>
                {webUrl && onOpenHotspotUrl && (
                  <button
                    type="button"
                    className={styles.iconBtn}
                    aria-label={`Open link for hotspot ${hotspot.name}`}
                    title="Open link in new tab"
                    onClick={() => onOpenHotspotUrl(hotspot)}
                  >
                    <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                  </button>
                )}
                <button
                  type="button"
                  className={styles.iconBtn}
                  aria-label={`Edit hotspot ${hotspot.name}`}
                  onClick={() => onEditHotspot(hotspot)}
                >
                  <FontAwesomeIcon icon={faPen} />
                </button>
                <Popconfirm
                  title="Delete this hotspot?"
                  onConfirm={() => onDeleteHotspot(hotspot.id)}
                  okText="Delete"
                  cancelText="Cancel"
                >
                  <button
                    type="button"
                    className={`${styles.iconBtn} ${styles.iconBtnDanger}`}
                    aria-label={`Delete hotspot ${hotspot.name}`}
                  >
                    <FontAwesomeIcon icon={faTrashCan} />
                  </button>
                </Popconfirm>
              </div>
            </div>
          );
        })}
        {!hotspots.length && (
          <p className={styles.emptyState}>No hotspots</p>
        )}
      </div>
    </section>
  );
}
